import React from "react";
import BottomNavbar from "../components/BottomNavbar";
import Navbar from "../components/Navbar";
import OurTeam from "../components/OurTeam";

const AboutUs = () => {
  return (
    <>
      <Navbar current="about" />
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 pb-20">
        {/* Hero Section */}
        <div
          className="relative w-full h-64 bg-cover bg-center flex items-center justify-center text-white text-center"
          style={{
            backgroundImage: "url('/internationalshipping.jpg')",
          }}
        >
          <div className="bg-black bg-opacity-50 p-6 rounded-lg mt-14 md:mt-20">
            <h1 className="text-2xl md:text-4xl font-bold">About Us</h1>
            <p className="text-sm md:text-lg mt-2">
              Learn more about our story and values
            </p>
          </div>
        </div>

        {/* Content Section */}
        <div className="max-w-4xl mx-auto py-12 px-6 text-gray-800">
          <h2 className="text-xl md:text-2xl font-semibold text-center">
            Who We Are
          </h2>
          <p className="mt-4 text-left md:text-lg">
            At Rehoboth Standard International Limited, we take pride in being
            an appointed distributor of Nigerchin wire and cable products. Our
            extensive range includes high-quality electrical wires, cables, and
            conductors made from aluminium and copper, all manufactured to
            British Standard (BS), International Electro-technical Commission
            (IEC) standards, and Nigeria Industrial Standard (NIS).
          </p>
        </div>

        {/* Our team */}
        <OurTeam />

        {/* Mission, Vision, Values */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 max-w-5xl mx-auto px-6 mt-10 pb-12">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <h3 className="text-lg md:text-xl font-semibold">Our Mission</h3>
            <p className="mt-2 text-gray-600">
              Our mission is simple—deliver top-quality products promptly.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <h3 className="text-lg md:text-xl font-semibold">Our Vision</h3>
            <p className="mt-2 text-gray-600">
              We aim to be the leading name in the electrical industry.
            </p>
          </div>
        </div>

        {/* Our Services */}
        <div className="max-w-6xl mx-auto px-6 py-12">
          <h2 className="text-xl md:text-2xl font-semibold text-center mb-6">
            Our Services
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-lg font-semibold mb-2">
                On-Site Delivery Services
              </h3>
              <p className="text-gray-600">
                We ensure timely and reliable delivery of cables and electrical
                materials to project locations across Nigeria and beyond.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-lg font-semibold mb-2">
                High-Quality Cable & Wire Supply
              </h3>
              <p className="text-gray-600">
                We provide a comprehensive range of certified electrical cables
                designed for efficiency, durability, and safety.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-lg font-semibold mb-2">
                Custom Electrical Cable Solutions
              </h3>
              <p className="text-gray-600">
                We offer specialized cable manufacturing and supply tailored to
                meet unique project requirements.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-lg font-semibold mb-2">
                Project Distributorship & Supply Partnership
              </h3>
              <p className="text-gray-600">
                We provide strategic supply solutions for large-scale projects.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-lg font-semibold mb-2">
                Technical Support & Consultation
              </h3>
              <p className="text-gray-600">
                We offer expert guidance to help clients select the right
                cables.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-lg font-semibold mb-2">
                Independent Cable Testing & Certification
              </h3>
              <p className="text-gray-600">
                We conduct industry-standard testing and certification for all
                electrical cables.
              </p>
            </div>
          </div>
        </div>

        {/* Download PDF Button */}
        <div className="mt-10">
          <a
            href="/brochure.pdf" // Make sure the file exists in the public folder
            download="Rehoboth_Brochure.pdf"
            className="bg-primary text-white px-6 py-3 rounded-lg font-semibold shadow-md hover:bg-primary-dark transition"
          >
            Download Product Catalogue
          </a>
        </div>
      </div>
      <BottomNavbar current="about" />
    </>
  );
};

export default AboutUs;
